/*
  Pagination buttons: controls to enable you to go to the previous or next page.

  @NOTE(mike, 2019-09-04) We're not making any assumptions about what's between the buttons for now
*/

import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import IconButton from "../IconButton/IconButton";
import { ButtonType, ButtonSize } from "../Button/Button";
import { ChevronLeft, ChevronRight } from "../../icons";

interface IPaginationProps {
  children: ReactNode;
  onPreviousButtonClick: () => void;
  onNextButtonClick: () => void;
  isPreviousButtonDisabled: boolean;
  isNextButtonDisabled: boolean;
}

export const BASE_CLASS_NAME = "pagination-buttons";

const Pagination: FC<IPaginationProps> = ({
  isPreviousButtonDisabled,
  isNextButtonDisabled,
  onPreviousButtonClick,
  onNextButtonClick,
  children,
}) => {
  return (
    <div className={`${BASE_CLASS_NAME}`}>
      <IconButton
        isRound
        size={ButtonSize.Small}
        className={classNames(`${BASE_CLASS_NAME}__arrow`, `${BASE_CLASS_NAME}__arrow--back`)}
        type={ButtonType.Secondary}
        disabled={isPreviousButtonDisabled}
        icon={<ChevronLeft />}
        tooltip={{ content: "Previous Page" }}
        onClick={onPreviousButtonClick}
      />
      <div className="pagination-buttons__content">{children}</div>
      <IconButton
        isRound
        size={ButtonSize.Small}
        className={classNames(`${BASE_CLASS_NAME}__arrow`, `${BASE_CLASS_NAME}__arrow--forward`)}
        type={ButtonType.Secondary}
        disabled={isNextButtonDisabled}
        icon={<ChevronRight />}
        tooltip={{ content: "Next Page" }}
        onClick={onNextButtonClick}
      />
    </div>
  );
};

export default Pagination;
